module.exports = __webpack_public_path__ + "img/austria-transport-accidents-female.f0ecefc9.png";